import { useRef, useState } from 'react';

// ponytail: honeypot + min-fill-time, no captcha service - stops scripted
// form spam without a backend or external dependency. Bypassed by a bot
// that renders CSS and waits, upgrade to reCAPTCHA if that shows up.
const MIN_FILL_SECONDS = 3;

export function useHoneypot() {
  const mountedAt = useRef(Date.now());
  const [honeypot, setHoneypot] = useState('');

  const isSpam = () =>
    honeypot !== '' || Date.now() - mountedAt.current < MIN_FILL_SECONDS * 1000;

  // Sent alongside the real payload so a server-side handler can redo this
  // check - the client-side isSpam() above is only a UX/cost shortcut, a
  // bot can skip straight to the fetch call and bypass it entirely.
  const spamCheckFields = () => ({ company: honeypot, startedAt: mountedAt.current });

  const honeypotFieldProps = {
    name: 'company',
    value: honeypot,
    onChange: (e) => setHoneypot(e.target.value),
    tabIndex: -1,
    autoComplete: 'off',
    'aria-hidden': true,
    style: { position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 },
  };

  return { honeypotFieldProps, isSpam, spamCheckFields };
}
